import React from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions'
import {CSS} from "../../css/tab_datatable";
import Style from "style-it";
import EkoDataTable from '../../components/elements/EkoDataTable'
import {FETCH_ZREPORTS} from "../../actions/types";
import Api from "../../util/Api";
import {toastr} from 'react-redux-toastr'
import UtilHelper from "../../util/UtilHelper";
import Util from "../../util/Util";

/**
 *
 */
class ZReportList extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            zreports: []
        };
    }


    componentWillMount() {
        this.fetchData();
    }

    fetchData() {
        this.props.fetchData('/zreport/list', FETCH_ZREPORTS);
    }

    openInsert(menuItem) {
        //localStorage.setItem("new_collection_from_who_type", menuItem);

        if (menuItem === 1) {
            this.props.router.push("/dashboard/salesInvoice/add/toCustomer");
        } else if (menuItem === 2) {
            this.props.router.push("/dashboard/salesInvoice/add/toSupplier");
        } else if (menuItem === 3) {
            this.props.router.push("/dashboard/salesInvoice/zreports/add");
        } else if (menuItem === 4) {
            this.props.router.push("/dashboard/salesInvoice/proforma/add");
        }else if (menuItem === 5) {
            this.props.router.push('/dashboard/salesInvoice/otherSales/add')
        }else if (menuItem === 6) {
            this.props.router.push('/dashboard/salesInvoice/soleprofv2/add')
        } else if (menuItem === 7) {
            this.props.router.push('/dashboard/salesInvoice/salesShipment/add')
        } else if (menuItem === 9) {
            this.props.router.push('/dashboard/salesInvoice/transportationContract/add')
        }
    }

    openUpdate(row) {
        this.props.router.push('/dashboard/salesInvoice/zreports/edit/' + row.id);
    }

    get moneyFields() {
        return [
            'amount_cash',
            'amount_creditcard',
            'amount_vat1',
            'amount_vat8',
            'amount_vat18',
            'amount_without_vat'
        ];
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.zreports) {

            const zreports = nextProps.zreports.map(report => {
                const moneyFields = UtilHelper.money.mapDecimalToMoney(this.moneyFields, report);
                const dateFields = {record_date: Util.convertFromDatabaseDate(report.record_date)};

                return {
                    ...report,
                    ...moneyFields,
                    ...dateFields
                }
            });


            this.setState({
                zreports
            });
        }
    }


    onDelete(row) {
        Api.delete('/zreport/' + row.id, (response, error) => {
            if (!error && response.status === 'ok') {
                toastr.success('Başarıyla Silindi');
                this.fetchData();
            } else {
                toastr.error(error.message ? error.message : 'Silinemedi');
            }
        });
    }

    get items() {
            const companySettings = JSON.parse(localStorage.getItem('company_settings'));
        var user_json = JSON.parse(localStorage.getItem("user"));
        var list = [];
        if(user_json.company_type == 9 || user_json.company_type == 6){
            window.location.replace("/dashboard/salesInvoice/soleprofv2s");
        }
        if(user_json.company_type == 9 || user_json.company_type == 6){
            list =  [
                {
                    id: 5,
                    link: "/dashboard/salesInvoice/soleprofv2s",
                    title: "Serbest Meslek Makbuzu"
                },
                {
                    id: 2,
                    link: "/dashboard/salesInvoice/zreports",
                    title: "Z Raporları"
                },
                {
                    id: 3,
                    link: '/dashboard/salesInvoice/proformas',
                    title: 'Teklifler/Siparişler'
                },
                {
                    id: 4,
                    link: "/dashboard/salesInvoice/otherSales",
                    title: "Diğer Gelirler"
                }
            ];
        }else{
            list =  [
                {
                    id: 1,
                    link: '/dashboard/salesInvoice',
                    title: 'Satışlar'
                },

                {
                    id: 2,
                    link: '/dashboard/salesInvoice/zreports',
                    title: 'Z Raporları'
                },
                {
                    id: 3,
                    link: '/dashboard/salesInvoice/proformas',
                    title: 'Teklifler/Siparişler'
                },
                {
                    id: 4,
                    link: "/dashboard/salesInvoice/otherSales",
                    title: "Diğer Gelirler"
                },
                {
                    id: 9,
                    link: "/dashboard/salesInvoice/transportationContract",
                    title: "Taşıma Sözleşmesi"
                }
            ];
            if (companySettings.show_z_reports !== 1) {
        list = list.filter(item => item.id !== 2);
      }
      if (companySettings.show_orders_quotes !== 1) {
        list = list.filter(item => item.id !== 3);
      }
      if (companySettings.show_other_incomes !== 1) {
        list = list.filter(item => item.id !== 4);
      }
      if (companySettings.show_transportation_contract !== 1) {
        list = list.filter(item => item.id !== 9);
      }
      
            if(Util.companyModules(2)===true){
                //@oguz stok modulu satın alındıysa
                list.push({
                    id: 7,
                    link: "/dashboard/salesInvoice/salesShipment",
                    title: "Sevk İrsaliyesi"
                },);
            }
            if(Util.companyModules(7)===true){
                //@oguz perakende satış modulu satın alındıysa
                list.push({
                    id: 8,
                    link: "/dashboard/SalesInvoice/SalesInvoiceRetailSales",
                    title: "Perakende Satış"
                },);
            }
        }
        return list;
    }


    render() {
            const companySettings = JSON.parse(localStorage.getItem('company_settings'));
        const insertMenux = this.props.viewOptions
            ? this.props.viewOptions.sales.addRecordMenu
            : false;
        if(insertMenux!=false){
            var user_json = JSON.parse(localStorage.getItem("user"));
            if(user_json.company_type == 9 || user_json.company_type == 6){
                var insertMenu = insertMenux.filter(obj => obj.id !== 1 && obj.id !== 2);
                insertMenu.unshift({id: 6, name: 'Serbest Meslek Makbuzu'});
            }else{
                insertMenu = insertMenux;
            }
        }
if (companySettings.show_z_reports !== 1) {
        insertMenu = insertMenu?.filter(item => item.id !== 3);
      }
      if (companySettings.show_orders_quotes !== 1) {
        insertMenu = insertMenu?.filter(item => item.id !== 4);
      }
      if (companySettings.show_other_incomes !== 1) {
        insertMenu = insertMenu?.filter(item => item.id !== 5);
      }
        return (
            <div>
                <a style={{"bottom": "6px", "position": "relative", "color": "grey"}}
                   onClick={Util.backButton.bind(this, "/dashboard")}><i className="fa fa-arrow-left"></i> Geri Dön</a>

                {
                    Style.it(
                        CSS,
                        <div>
                            <EkoDataTable
                                title="ZRaporları"
                                tabMenu={this.items}
                                selectedTab={2}
                                openInsert={this.openInsert.bind(this)}
                                openUpdate={this.openUpdate.bind(this)}
                                onDelete={this.onDelete.bind(this)}
                                data={this.state.zreports}
                                insertMenu={insertMenu}
                                name={"zreports"}
                            />
                        </div>
                    )
                }
            </div>
        );


    }
}

const mapStateToProps = (state) => {
    return {
        zreports: state.data.zreports,
        viewOptions: state.data.viewOptions

    }
}

export default connect(mapStateToProps, actions)(ZReportList);